<template>
    <div class="inner-container">
        <div class="section-title budget">
            <i class="icon icon-calculator-coins"></i>
            <span>Бюджет</span>
        </div>
        <div class="section-subtitle" v-show="formCodeURL === ''">
            <i class="icon icon-grid"></i><span>
                {{ $t("app.links.budget_requests") }}
            <budget-forms-list :curFormSelect="'/form01-123'"/></span>
        </div>

        <div 
            v-show="categoryMode" 
            class="filter-container filter-container_budget-forms"
        >
            <budget-header 
                ref="budgetHeader" 
                v-if="isHeaderVisible"
                :form="form" 
                :yearReq="true" 
                :openDisabled="openDisabled"
                :currTabName="currTabName"
                @chgData="changeHeader" 
                @setProgress="setProgress"
                @setFilterOpenBtnClicked="setFilterOpenBtnClicked"
            ></budget-header>
        </div>

        <breadcrumbs-filter v-show="categoryMode && !enteredFromOtherMode" :header="bcHeader" :data-type-filter="dataTypeFilter"
                            :variant-name="variantName" @openFilterByRef="openFilterByRef"/>
        <b-progress
                variant="success"
                v-if="!enteredFromOtherMode"
                v-show="progress < 100 && progress > 0"
                height="10px"
                :value="progress"
                striped
                animated
        ></b-progress>
        <filter-empty-placeholder v-if="enteredFromOtherMode" />
            
        <b-overlay class="bf-overlay" rounded="sm">
            <Form03_149
                ref="curForm"
                v-if="formCodeURL==='03-149'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
                @setCurrTabName="setCurrTabName"
            ></Form03_149>
            <Form02_149
                ref="curForm"
                v-if="formCodeURL==='02-149'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form02_149>
            <Form02_149_v2
                ref="curForm"
                v-if="formCodeURL==='02-149_v2'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form02_149_v2>
            <Form04_149
                ref="curForm"
                v-if="formCodeURL==='04-149'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form04_149>
            <Form01_149
                ref="curForm"
                v-if="formCodeURL==='01-149'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form01_149>
            <Form01_324
                ref="curForm"
                v-if="formCodeURL==='01-324'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form01_324>
            <Form339
                ref="curForm"
                v-if="formCodeURL==='339'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form339>
            <Form322
                ref="curForm"
                v-if="formCodeURL==='322'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form322>
            <Form322_v2
                ref="curForm"
                v-if="formCodeURL==='322_v2'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form322_v2>
            <Form01_158
                ref="curForm"
                v-if="formCodeURL==='01-158'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form01_158>
            <Form154
                ref="curForm"
                v-if="formCodeURL==='154'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form154>
            <Form154_v2
                ref="curForm"
                v-if="formCodeURL==='154_v2'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form154_v2>
            <Form155
                ref="curForm"
                v-if="formCodeURL==='155'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form155>
            <Form155_v2
                ref="curForm"
                v-if="formCodeURL==='155_v2'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form155_v2>
            <Form156
                ref="curForm"
                v-if="formCodeURL==='156'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form156>
            <Form156_v2
                ref="curForm"
                v-if="formCodeURL==='156_v2'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form156_v2>
            <Form157
                ref="curForm"
                v-if="formCodeURL==='157'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form157>
            <Form157_v2
                ref="curForm"
                v-if="formCodeURL==='157_v2'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form157_v2>
            <Form163
                ref="curForm"
                v-if="formCodeURL==='163'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form163>
            <Form163_v2
                ref="curForm"
                v-if="formCodeURL==='163_v2'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form163_v2>
            <Form165
                ref="curForm"
                v-if="formCodeURL==='165'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form165>
            <Form165_v2
                ref="curForm"
                v-if="formCodeURL==='165_v2'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form165_v2>
            <Form812
                ref="curForm"
                v-if="formCodeURL==='812'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form812>
            <Form812_v2
                ref="curForm"
                v-if="formCodeURL==='812_v2'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form812_v2>
            <Form321
                ref="curForm"
                v-if="formCodeURL==='321'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form321>
            <Form321_v2
                ref="curForm"
                v-if="formCodeURL==='321_v2'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form321_v2>
            <Form419
                ref="curForm"
                v-if="formCodeURL==='419'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form419>
            <Form419_v2
                ref="curForm"
                v-if="formCodeURL==='419_v2'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form419_v2>
            <Form133
                ref="curForm"
                v-if="formCodeURL==='133'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form133>
            <Form133_v2
                ref="curForm"
                v-if="formCodeURL==='133_v2'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form133_v2>
            <Form813
                ref="curForm"
                v-if="formCodeURL==='813'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form813>
            <Form813_v2
                ref="curForm"
                v-if="formCodeURL==='813_v2'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form813_v2>
            <Form814
                ref="curForm"
                v-if="formCodeURL==='814'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form814>
            <Form814_v2
                ref="curForm"
                v-if="formCodeURL==='814_v2'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form814_v2>
            <Form815
                ref="curForm"
                v-if="formCodeURL==='815'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form815>
            <Form815_v2
                ref="curForm"
                v-if="formCodeURL==='815_v2'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form815_v2>
            <Form412
                ref="curForm"
                v-if="formCodeURL==='412'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form412>
            <Form412_v2
                ref="curForm"
                v-if="formCodeURL==='412_v2'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form412_v2>
            <Form411
                ref="curForm"
                v-if="formCodeURL==='411'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form411>
            <Form411_v2
                ref="curForm"
                v-if="formCodeURL==='411_v2'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form411_v2>
            <Form417
                ref="curForm"
                v-if="formCodeURL==='417'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form417>
            <Form417_v2
                ref="curForm"
                v-if="formCodeURL==='417_v2'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form417_v2>
            <Form418
                ref="curForm"
                v-if="formCodeURL==='418'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form418>
            <Form418_v2
                ref="curForm"
                v-if="formCodeURL==='418_v2'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form418_v2>
            <Form421
                ref="curForm"
                v-if="formCodeURL==='421'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form421>
            <Form313
                ref="curForm"
                v-if="formCodeURL==='313'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form313>
            <Form312
                ref="curForm"
                v-if="formCodeURL==='312'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form312>
            <Form421_v2
                ref="curForm"
                v-if="formCodeURL==='421_v2'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form421_v2>
            <Form423
                ref="curForm"
                v-if="formCodeURL==='423'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form423>
            <Form423_v2
                ref="curForm"
                v-if="formCodeURL==='423_v2'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form423_v2>
            <Form422
                ref="curForm"
                v-if="formCodeURL==='422'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form422>
            <Form422_v2
                ref="curForm"
                v-if="formCodeURL==='422_v2'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form422_v2>
            <Form429
                ref="curForm"
                v-if="formCodeURL==='429'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form429>
            <Form429_v2
                ref="curForm"
                v-if="formCodeURL==='429_v2'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form429_v2>
            <Form212
                ref="curForm"
                v-if="formCodeURL==='212'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form212>
            <Form212_v2
                ref="curForm"
                v-if="formCodeURL==='212_v2'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form212_v2>
            <Form213
                ref="curForm"
                v-if="formCodeURL==='213'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form213>
            <Form213_v2
                ref="curForm"
                v-if="formCodeURL==='213_v2'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form213_v2>
            <Form711
                ref="curForm"
                v-if="formCodeURL==='711'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form711>
            <Form711_v2
                ref="curForm"
                v-if="formCodeURL==='711_v2'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form711_v2>
            <Form712
                ref="curForm"
                v-if="formCodeURL==='712'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form712>
            <Form712_v2
                ref="curForm"
                v-if="formCodeURL==='712_v2'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form712_v2>
            <Form331
                ref="curForm"
                v-if="formCodeURL==='331'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form331>
            <Form331_v2
                ref="curForm"
                v-if="formCodeURL==='331_v2'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form331_v2>
            <Form359
                ref="curForm"
                v-if="formCodeURL==='359'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form359>
            <Form514
                ref="curForm"
                v-if="formCodeURL==='514'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form514>
            <Form514_v2
                ref="curForm"
                v-if="formCodeURL==='514_v2'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form514_v2>
            <Form513
                ref="curForm"
                v-if="formCodeURL==='513'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form513>
            <Form513_v2
                ref="curForm"
                v-if="formCodeURL==='513_v2'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form513_v2>
            <Form168
                ref="curForm"
                v-if="formCodeURL==='168'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form168>
            <Form01_361
                ref="curForm"
                v-if="formCodeURL==='01-361'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form01_361>
            <Form341
                ref="curForm"
                v-if="formCodeURL==='341'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form341>
            <Form374
                ref="curForm"
                v-if="formCodeURL==='374'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form374>
            <Form612
                ref="curForm"
                v-if="formCodeURL==='612'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form612>
            <Form612_v2
                ref="curForm"
                v-if="formCodeURL==='612_v2'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form612_v2>
            <Form01_166
                ref="curForm"
                v-if="formCodeURL==='01-166'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form01_166>
            <Form02_166
                ref="curForm"
                v-if="formCodeURL==='02-166'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form02_166>
            <Form01_161
                ref="curForm"
                v-if="formCodeURL==='01-161'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form01_161>
            <Form01_161_v2
                ref="curForm"
                v-if="formCodeURL==='01-161_v2'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form01_161_v2>
            <Form01_136
                ref="curForm"
                v-if="formCodeURL==='01-136'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form01_136>
            <Form01_136_v2
                ref="curForm"
                v-if="formCodeURL==='01-136_v2'"
                @setForm="setForm"
                @setOpenDisabled="setOpenDisabled"
                @setCategoryMode="setCategoryMode"
                @setProgress="setProgress"
                @setDataForBreadCrumbs="setDataForBreadCrumbs"
            ></Form01_136_v2>
        </b-overlay>
    </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import BudgetHeader from '@/modules/budget-request/budget-header-new-1.vue';
import BudgetFormsList from '@/modules/budget-request/components/budget-forms-list.vue';
import BreadcrumbsFilter from '@/modules/budget-request/components/breadcrumbs-filter.vue';
import FilterEmptyPlaceholder from '@/modules/budget-request/components/filter-empty-placeholder.vue';

import Form03_149 from "./Form03_149.vue";
import Form02_149 from "./Form02_149.vue";
import Form01_149 from "./Form01_149.vue";
import Form01_324 from "./Form01_324.vue";
import Form02_149_v2 from "./Form02_149_v2.vue";
import Form04_149 from "./Form04_149.vue";
import Form339 from "@/modules/budget-request/arbitrary-forms/Form339.vue"
import Form322 from "@/modules/budget-request/arbitrary-forms/Form322.vue"
import Form322_v2 from "@/modules/budget-request/arbitrary-forms/Form322_v2.vue"
import Form154 from "@/modules/budget-request/arbitrary-forms/Form154.vue"
import Form154_v2 from "@/modules/budget-request/arbitrary-forms/Form154_v2.vue"
import Form155 from "@/modules/budget-request/arbitrary-forms/Form155.vue"
import Form155_v2 from "@/modules/budget-request/arbitrary-forms/Form155_v2.vue"
import Form156 from "@/modules/budget-request/arbitrary-forms/Form156.vue"
import Form156_v2 from "@/modules/budget-request/arbitrary-forms/Form156_v2.vue"
import Form157 from "@/modules/budget-request/arbitrary-forms/Form157.vue"
import Form157_v2 from "@/modules/budget-request/arbitrary-forms/Form157_v2.vue"
import Form165 from "@/modules/budget-request/arbitrary-forms/Form165.vue"
import Form163 from "@/modules/budget-request/arbitrary-forms/Form163.vue"
import Form163_v2 from "@/modules/budget-request/arbitrary-forms/Form163_v2.vue"
import Form165_v2 from "@/modules/budget-request/arbitrary-forms/Form165_v2.vue"
import Form812 from "@/modules/budget-request/arbitrary-forms/Form812.vue"
import Form812_v2 from "@/modules/budget-request/arbitrary-forms/Form812_v2.vue"
import Form01_158 from "./Form01_158.vue";
import Form321 from "@/modules/budget-request/arbitrary-forms/Form321.vue"
import Form321_v2 from "@/modules/budget-request/arbitrary-forms/Form321_v2.vue"
import Form419 from "@/modules/budget-request/arbitrary-forms/Form419.vue"
import Form419_v2 from "@/modules/budget-request/arbitrary-forms/Form419_v2.vue"
import Form133 from "@/modules/budget-request/arbitrary-forms/Form133.vue"
import Form133_v2 from "@/modules/budget-request/arbitrary-forms/Form133_v2.vue"
import Form813 from "@/modules/budget-request/arbitrary-forms/Form813.vue"
import Form813_v2 from "@/modules/budget-request/arbitrary-forms/Form813_v2.vue"
import Form814 from "@/modules/budget-request/arbitrary-forms/Form814.vue"
import Form814_v2 from "@/modules/budget-request/arbitrary-forms/Form814_v2.vue"
import Form815 from "@/modules/budget-request/arbitrary-forms/Form815.vue"
import Form815_v2 from "@/modules/budget-request/arbitrary-forms/Form815_v2.vue"
import Form412 from "@/modules/budget-request/arbitrary-forms/Form412.vue"
import Form412_v2 from "@/modules/budget-request/arbitrary-forms/Form412_v2.vue"
import Form411 from "@/modules/budget-request/arbitrary-forms/Form411.vue"
import Form411_v2 from "@/modules/budget-request/arbitrary-forms/Form411_v2.vue"
import Form417 from "@/modules/budget-request/arbitrary-forms/Form417.vue"
import Form417_v2 from "@/modules/budget-request/arbitrary-forms/Form417_v2.vue"
import Form418 from "@/modules/budget-request/arbitrary-forms/Form418.vue"
import Form418_v2 from "@/modules/budget-request/arbitrary-forms/Form418_v2.vue"
import Form421 from "@/modules/budget-request/arbitrary-forms/Form421.vue"
import Form312 from "@/modules/budget-request/arbitrary-forms/Form312.vue"
import Form313 from "@/modules/budget-request/arbitrary-forms/Form313.vue"
import Form421_v2 from "@/modules/budget-request/arbitrary-forms/Form421_v2.vue"
import Form423 from "@/modules/budget-request/arbitrary-forms/Form423.vue"
import Form423_v2 from "@/modules/budget-request/arbitrary-forms/Form423_v2.vue"
import Form422 from "@/modules/budget-request/arbitrary-forms/Form422.vue"
import Form422_v2 from "@/modules/budget-request/arbitrary-forms/Form422_v2.vue"
import Form429 from "@/modules/budget-request/arbitrary-forms/Form429.vue"
import Form429_v2 from "@/modules/budget-request/arbitrary-forms/Form429_v2.vue"
import Form212 from "@/modules/budget-request/arbitrary-forms/Form212.vue"
import Form212_v2 from "@/modules/budget-request/arbitrary-forms/Form212_v2.vue"
import Form213 from "@/modules/budget-request/arbitrary-forms/Form213.vue"
import Form213_v2 from "@/modules/budget-request/arbitrary-forms/Form213_v2.vue"
import Form711 from "@/modules/budget-request/arbitrary-forms/Form711.vue"
import Form711_v2 from "@/modules/budget-request/arbitrary-forms/Form711_v2.vue"
import Form712 from "@/modules/budget-request/arbitrary-forms/Form712.vue"
import Form712_v2 from "@/modules/budget-request/arbitrary-forms/Form712_v2.vue"
import Form331 from "@/modules/budget-request/arbitrary-forms/Form331.vue"
import Form331_v2 from "@/modules/budget-request/arbitrary-forms/Form331_v2.vue"
import Form359 from "@/modules/budget-request/arbitrary-forms/Form359.vue"
import Form514 from "@/modules/budget-request/arbitrary-forms/Form514.vue"
import Form514_v2 from "@/modules/budget-request/arbitrary-forms/Form514_v2.vue"
import Form513 from "@/modules/budget-request/arbitrary-forms/Form513.vue"
import Form513_v2 from "@/modules/budget-request/arbitrary-forms/Form513_v2.vue"
import Form168 from "@/modules/budget-request/arbitrary-forms/Form168.vue"
import Form01_361 from "@/modules/budget-request/arbitrary-forms/Form01_361.vue"
import Form341 from "@/modules/budget-request/arbitrary-forms/Form341.vue"
import Form374 from "@/modules/budget-request/arbitrary-forms/Form374.vue"
import Form612 from "@/modules/budget-request/arbitrary-forms/Form612.vue"
import Form612_v2 from "@/modules/budget-request/arbitrary-forms/Form612_v2.vue"
import Form01_166 from "@/modules/budget-request/Form01_166.vue"
import Form02_166 from "@/modules/budget-request/Form02_166.vue"
import Form01_161 from "@/modules/budget-request/Form01_161.vue"
import Form01_161_v2 from "@/modules/budget-request/Form01_161_v2.vue"
import Form01_136 from "@/modules/budget-request/Form01_136.vue"
import Form01_136_v2 from "@/modules/budget-request/Form01_136_v2.vue"

export default {
    name: 'Forms',
    components: {   
                    BudgetFormsList,
                    BreadcrumbsFilter,
                    FilterEmptyPlaceholder,
                    BudgetHeader,
                    Form03_149,
                    Form02_149,
                    Form01_149,
                    Form01_324,
                    Form02_149_v2,
                    Form04_149,
                    Form339,
                    Form322,
                    Form322_v2,
                    Form154,
                    Form154_v2,
                    Form155,
                    Form155_v2,
                    Form156,
                    Form156_v2,
                    Form157,
                    Form157_v2,
                    Form163,
                    Form163_v2,
                    Form165,
                    Form165_v2,
                    Form812,
                    Form812_v2,
                    Form01_158,
                    Form321,
                    Form321_v2,
                    Form419,
                    Form419_v2,
                    Form133,
                    Form133_v2,
                    Form813,
                    Form813_v2,
                    Form814,
                    Form814_v2,
                    Form815,
                    Form815_v2,
                    Form412,
                    Form412_v2,
                    Form411,
                    Form411_v2,
                    Form417,
                    Form417_v2,
                    Form418,
                    Form418_v2,
                    Form421,
                    Form312,
                    Form313,
                    Form421_v2,
                    Form423,
                    Form423_v2,
                    Form422,
                    Form422_v2,
                    Form429,
                    Form429_v2,
                    Form212,
                    Form212_v2,
                    Form213,
                    Form213_v2,
                    Form711,
                    Form711_v2,
                    Form712,
                    Form712_v2,
                    Form331,
                    Form331_v2,
                    Form359,
                    Form514,
                    Form514_v2,
                    Form513,
                    Form513_v2,
                    Form168,
                    Form01_361,
                    Form341,
                    Form374,
                    Form612,
                    Form612_v2,
                    Form01_166,
                    Form02_166,
                    Form01_161,
                    Form01_161_v2,
                    Form01_136,
                    Form01_136_v2,
                },
    mixins: [],
    data() {
        return {
            form: {
                code: '',
                name_ru: '',
                name_kk: ''
            },
            formCodeURL: '',
            progress: 0,
            openDisabled: false,
            categoryMode: true,
            bcHeader: {},
            dataTypeFilter: null,
            variantName: null,
            currTabName: null,
            formsWithTabs: ['03-149'],
            isHeaderVisible: true,
            filterOpenBtnClicked: false,
        };
    },

    watch: {
        $route(to, from) {
            if (to.path !== from.path && !this.filterOpenBtnClicked) {
                this.reloadForm();
            }
            this.filterOpenBtnClicked = false;
        },
    },

    computed: {
        // роут открыт по своему "голому" пути (без параметров фильтра в урле) -
        // значит пользователь пришёл не по прямой ссылке
        enteredFromOtherMode() {
            return ('/' + this.$route.name) === this.$route.path;
        },
        // не показываем плейсхолдер, пока идёт обработка прямой ссылки -
        // то же условие, что и в forms-handler-mixin(-1).js для остальных форм
        showFilterPlaceholder() {
            const budgetHeader = this.$refs && this.$refs.budgetHeader;
            return !!(budgetHeader && budgetHeader.isDirectLinkInProgress);
        },
    },

    methods: {
        changeHeader(data) {
            this.formCodeURL = this.getFormCode(data);
            if (!this.formsWithTabs.includes(this.formCodeURL)) {
                this.setCurrTabName(null);
            }
            this.$nextTick(() => {
                this.$refs.curForm.changeHeader(data);
            })
        },

        setProgress(val) {
            this.progress = val;
        },

        setForm(form) {
            this.form = form;
        },

        setOpenDisabled(val) {
            this.openDisabled = val;
        },

        setCategoryMode(val) {
            this.categoryMode = val;
        },

        setDataForBreadCrumbs(header, curHeader) {
            const formName = curHeader.form;
            const spfName = curHeader.spf;
        // TODO Удалить formName, spfName, dataTypeFilter, variantName из миксинов когда все формы пенесены на этот формат
            this.bcHeader = {...header, formName: formName, spfName: spfName, gu: curHeader.gu, gkkp: curHeader.curGkkp};
            this.dataTypeFilter = curHeader.dataType;
            this.variantName = curHeader.budgetVersion;
        },
        
        // TODO Удалить этот метод из миксинов когда все формы пенесены на этот формат
        openFilterByRef(refName) {
            this.$refs.budgetHeader.openFilterByRef(refName, this.bcHeader.mode);
        },

        setCurrTabName(val) {
            this.currTabName = val;
        },

        reloadForm() {
            this.isHeaderVisible = false;
            this.formCodeURL = '';
            this.$nextTick(() => {
                this.isHeaderVisible = true; // Перезагружает компонент
            });
        },

        setFilterOpenBtnClicked(val) {
            this.filterOpenBtnClicked = val;
        },
        
        getFormCode(data) {
            let formCode = '';
            if ('form' in data) {
                const form = data.form; 
                if ('code' in form) formCode = data.form.code;
                if ('version' in form && form.version) formCode += `_v${form.version}`;
            }
            return formCode;
        }
    }
}
</script>

<style scoped>
    .filter-container_budget-forms {
        z-index: 1010;
        width: fit-content;
    }
    .bf-overlay{
        min-height: 100px;
    }

</style>